var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"photo"},[_c('router-link',{attrs:{"to":"/profile"}},[_c('img',{attrs:{"src":_vm.user.image}})])],1),_c('div',{staticClass:"border-b border-gray-500 mt-12 pb-2 mx-1"})])}
var staticRenderFns = []

export { render, staticRenderFns }